import { ShopperAgentDiscountConfigSchema } from "@redotech/redo-shopper-agent-settings-common/discount-config";
import * as z from "zod";

export const updateShopperAgentDiscount = {
  name: "updateShopperAgentDiscount" as const,
  input: z.object({
    discountConfig: ShopperAgentDiscountConfigSchema.nullable(),
  }),
  output: z.object({ success: z.boolean() }),
};
